import { useState, useEffect, useCallback } from "react";

const Navbar = () => {
  const loggedIn = false; // Static landing site — never show auth state
  const [scrolled, setScrolled] = useState(false);

  const scrollToHash = useCallback((e: React.MouseEvent<HTMLAnchorElement>, hash: string) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      // Navigate home, then scroll after page renders
      window.location.href = "/" + hash;
      return;
    }
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      aria-label="Main navigation"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? "rgba(242,238,234,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(16px) saturate(1.3)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(16px) saturate(1.3)" : "none",
        borderBottom: scrolled
          ? "1px solid rgba(26,38,22,0.06)"
          : "1px solid transparent",
        boxShadow: scrolled ? "0 1px 8px rgba(26,38,22,0.04)" : "none",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <a href="/" className="flex items-center gap-0 group">
          <img
            src="/foreman-logo-new.png"
            alt="Foreman"
            className="h-16 w-16 -my-3 -mr-3 transition-transform duration-200 group-hover:scale-105"
            style={{ objectFit: "contain" }}
          />
          <span
            style={{
              fontSize: "20px",
              fontWeight: 500,
              letterSpacing: "-0.02em",
              color: "#1a2616",
              fontFamily: "'Clash Grotesk', -apple-system, BlinkMacSystemFont, sans-serif",
            }}
          >
            Foreman
          </span>
        </a>

        <div className="hidden sm:flex items-center gap-6">
          <a
            href="/#how-it-works"
            onClick={(e) => scrollToHash(e, "#how-it-works")}
            className="transition-colors duration-200"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "rgba(26,38,22,0.75)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1a2616";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "rgba(26,38,22,0.75)";
            }}
          >
            How it works
          </a>
          <a
            href="/#pricing"
            onClick={(e) => scrollToHash(e, "#pricing")}
            className="transition-colors duration-200"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "rgba(26,38,22,0.75)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1a2616";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "rgba(26,38,22,0.75)";
            }}
          >
            Pricing
          </a>
          <a
            href="/overview"
            className="transition-colors duration-200"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              color: "rgba(26,38,22,0.75)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1a2616";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "rgba(26,38,22,0.75)";
            }}
          >
            Overview
          </a>

          <div className="flex items-center gap-3 ml-2">
            {loggedIn ? (
              <a
                href="/app"
                className="font-medium rounded-lg transition-all duration-300"
                style={{
                  fontSize: "14px",
                  padding: "10px 28px",
                  background: "#1a2616",
                  color: "#f2eeea",
                  boxShadow: "0 2px 8px rgba(26,38,22,0.1)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 4px 16px rgba(26,38,22,0.35)";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow =
                    "0 2px 8px rgba(26,38,22,0.1)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Dashboard
              </a>
            ) : (
              <>
                <a
                  href="/login"
                  className="transition-colors duration-200"
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                    color: "rgba(26,38,22,0.75)",
                    padding: "10px 16px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#1a2616";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "rgba(26,38,22,0.75)";
                  }}
                >
                  Sign in
                </a>
                <a
                  href="/get-started"
                  className="font-medium rounded-lg transition-all duration-300"
                  style={{
                    fontSize: "14px",
                    padding: "10px 28px",
                    background: "#1a2616",
                    color: "#f2eeea",
                    boxShadow: "0 2px 8px rgba(26,38,22,0.1)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 16px rgba(26,38,22,0.35)";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(26,38,22,0.1)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  Get Started Free
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
